import React, { useEffect, useState, useRef } from 'react'
import people from '../../../../pre-reg/img/peopleCropped.png'
import scanner from '../../../../pre-reg/img/WAQR3x.png'
import Navbar from '../../../../components/HomeNewPageComponents/Navbar/Navbar'
import Scrollbars from 'react-custom-scrollbars'
import Footer from '../../../../components/HomeNewPageComponents/Footer/Footer'
import FixedAppDirectingFooter from '../../../../components/HomeNewPageComponents/FixedAppDirectingFooter/FixedAppDirectingFooter'
import { fireAjaxRequest, history } from '../../../../utils/Utility'
import backArrowEResearch from '../../../../assets/images/backArrowEResearch.svg'
import { AADHAAR_CONSENT_API, AADHAAR_OFFLINE_API, GET_AADHAAR_API, GET_PERSONAL_INFO, GET_PINCODE_DETAILS, KYC_VERIFY_PAN, POST_KYC_PROFILE, PUT_USER_DETAILS } from '../../../../utils/Api'
import './ProfileSectionPostReg.css'
import downArrowLight from '../../../../assets/images/downArrowLight.svg'
import { toast } from 'react-toastify'
import dropdownArrow from '../../../../assets/images/dropdownArrow.svg';
import helpLaptop from '../../../../assets/images/help-laptop-img.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Popup from 'reactjs-popup'
import greenPlus from '../../../../assets/images/greenPlus.svg'
import greenCross from '../../../../assets/images/greenCross.svg'
import idType from '../../../../assets/images/ID_Type.svg'
import crossInput from '../../../../assets/images/crossInput.svg'
import fingerPrint from '../../../../assets/images/fingerprint.svg'
import adharLogo from '../../../../assets/images/AdharLogo.svg'
import successLaptop from '../../../../assets/images/laptop screen.svg'
import firmNameImg from '../../../../assets/images/FirmNameImg.svg'
import greenRolling from '../../../../assets/images/Rolling-1.1s-200px.svg'
import greenTick from '../../../../assets/images/greenTick.svg'
import infoAdharConsent from '../../../../assets/images/info-small.svg'
import { detect } from 'detect-browser'
import Axios from 'axios'

function ProfileSectionPostReg() {
    const fileInputRef = useRef(null);

    const [userPersonalDetails, setUserPersonalDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('personal');

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [pin, setPin] = useState('');
    const [state, setStateName] = useState('');
    const [house, setHouse] = useState('');
    const [city, setCity] = useState('');
    const [district, setDistrict] = useState('');

    const [activeHelpTab, setActiveHelpTab] = useState('emandi');

    const [isLoading, setIsLoading] = useState(false);

    const [accountTypeSelected, setAccountTypeSelected] = useState('INDIVIDUAL_TRADER');
    const [individualPanNumber, setIndividualPanNumber] = useState('');
    const [individualPanName, setIndividualPanName] = useState('');
    const [individualPanDOB, setIndividualPanDOB] = useState('');

    const [showDiffNamesPopup, setShowDiffNamesPopup] = useState(false);

    const [showAddIdSelectPopup, setShowAddIdSelectPopup] = useState(false);
    const [addIdsList, setAddIdsList] = useState([
        {label: "PAN Card" , value: "PAN"},
        {label: "Voter Id" , value: "VOTER_ID"},
        {label: "Driving License" , value: "DRIVING_LICENSE"},
        {label: "Passport" , value: "PASSPORT"},
        {label: "Aadhar Card" , value: "AADHAR"},
        {label: "Udyog Aadhar" , value: "UDYOG_AADHAR"},
        {label: "Bank Statement" , value: "BANK_ACCOUNT"},
        {label: "GSTIN NUMBER" , value: "GSTIN_NUMBER"}
    ]);
    const [itemToAddKyc, setItemToAddKyc] = useState('');
    const [selectedKYCItemFieldsPopup, setSelectedKYCItemFieldsPopup] = useState(false);
    const [itemToAddKycValue, setItemToAddKycValue] = useState('');
    const [itemToAddKycName, setItemToAddKycName] = useState('');
    const [itemToAddKycDOB, setItemToAddKycDOB] = useState('');
    const [itemToAddKycFileNo, setItemToAddKycFileNo] = useState('');
    const [itemToAddKycDateOfIssue, setItemToAddKycDateOfIssue] = useState('');
    const [itemToAddKycIFSC, setItemToAddKycIFSC] = useState('');
    const [itemToAddKycOtpPopup, setItemToAddKycOtpPopup] = useState('');
    const [itemToAddKycAdharOtpValue, setItemToAddKycAdharOtpValue] = useState([]);
    const [counter, setCounter] = useState(0);
    const [successfullyAddedKycPopup, setSuccessfullyAddedKycPopup] = useState(false);
    const [aadharAccessKey, setAadharAccessKey] = useState('');
    const [aadharShareCode, setAadharShareCode] = useState('');
    const [showUploadAdhar, setShowUploadAdhar] = useState(false);
    const [adharFileZip, setAdharFileZip] = useState(null);
    const [showFirmNameRolling, setShowFirmNameRolling] = useState(false);
    const [showFirmNameTick, setShowFirmNameTick] = useState(false);
    const [isCheckedAadharConsent, setIsCheckedAadharConsent] = useState(false);
    const [showAdharConsentPopup, setShowAdharConsentPopup] = useState(false);
    // const CustomInput = ({ value, onClick }) => (
    //     <input
    //       value={value}
    //       onClick={onClick}
    //       onFocus={onClick}
    //       readOnly // Set readOnly to true to disable manual editing
    //       style={{ cursor: 'pointer' }} // Add cursor style to indicate clickable input
    //     />
    //   );

    useEffect(() => {
        // call us popup
        let chatOverlay = document.querySelector('.chatOverlay')
        let callBtn = document.querySelectorAll('.call')
        let chatCross = document.querySelector('.chatRight > div > svg:last-of-type')

        callBtn.forEach((ele) => {
        ele.addEventListener('click', () => {
            chatOverlay.classList.add('chatDisplay')
            document.body.style.overflow = 'hidden'
            let elm = document.querySelector('.toaster')
             elm.style.display= "none";
        })
        })

        chatCross.addEventListener('click', () => {
        document.body.style.overflow = 'auto'
        chatOverlay.classList.remove('chatDisplay')
        })
        let callUsNumber = document.querySelector('.chatContent>div:first-of-type')

        callUsNumber.addEventListener('click', () => {
        let elm = document.querySelector('.toaster')
        elm.style.display= "flex";
        var newone = elm.cloneNode(true);
        elm.parentNode.replaceChild(newone, elm);
        })
        
        if (userPersonalDetails?.accountType === "ORGANIZATION_TRADER") {
            const excludedDocuments = ["VOTER_ID", "DRIVING_LICENSE", "PASSPORT", "AADHAR"];
            const filteredDocuments = addIdsList.filter(doc => !excludedDocuments.includes(doc.value));
            console.log(filteredDocuments);
            setAddIdsList(filteredDocuments);
        }
        //user details
        getUserDetails();

    },[])

    // counter for otp exporation
    useEffect(() => {
        const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        return () => clearInterval(timer);
      }, [counter]);


    useEffect(() => {
        let fullName = userPersonalDetails && userPersonalDetails?.name;
        if(fullName){
            let nameWords = fullName.split(" ");
            let numWords = nameWords.length;

            let firstName, lastName;
            if (numWords === 1) {
                firstName = nameWords[0];
            } else {
                lastName = nameWords[numWords - 1];
                firstName = nameWords.slice(0, numWords - 1).join(" ");
            }
            setFirstName(firstName)
            setLastName(lastName)
        }
        setPhoneNumber(userPersonalDetails && userPersonalDetails?.phoneNo)
        setEmail(userPersonalDetails && userPersonalDetails?.email)
        setPin(userPersonalDetails && userPersonalDetails?.pincode)
        setStateName(userPersonalDetails && userPersonalDetails?.state)
        setHouse(userPersonalDetails && userPersonalDetails?.address)
        setCity(userPersonalDetails && userPersonalDetails?.town)
        setDistrict(userPersonalDetails && userPersonalDetails?.district)

        setAccountTypeSelected(userPersonalDetails?.accountType)

        const filteredAddIdList = addIdsList.filter(obj => !userPersonalDetails?.kyc.some(kycObj => kycObj.type === obj.value));
        if (userPersonalDetails?.accountType === "ORGANIZATION_TRADER") {
            const excludedDocuments = ["VOTER_ID", "DRIVING_LICENSE", "PASSPORT", "AADHAR"];
            const filteredDocuments = filteredAddIdList.filter(doc => !excludedDocuments.includes(doc.value));
            console.log(filteredDocuments);
            setAddIdsList(filteredDocuments);
        }else{
            setAddIdsList(filteredAddIdList);
        }
        
    },[userPersonalDetails])

    const getUserDetails = async()=>{
        setIsLoading(true)
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        try {
            const resp = await fireAjaxRequest(`${GET_PERSONAL_INFO}/${userInfo.user.id}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${userInfo.token}`
                },  
            });
            if (resp && resp.phoneNo) {
                setIsLoading(false)
                setUserPersonalDetails(resp);
            } else {
            }
        } catch (err) {
            toast.error("Unable to get the account deatils")
        }
    }

    const handleTabClick = (tab) =>{
        setActiveTab(tab)
    }
    const fetchPinCodeDetails = async (code) => {
        return await fireAjaxRequest(`${GET_PINCODE_DETAILS}/${code}`);
    };

    const handlePincodeChange = async(e) =>{
        var pincodeValue = e.target.value;
        pincodeValue = pincodeValue.replace(/\D/g, '');
        setPin(pincodeValue);
        if(pincodeValue.length === 6){
            setIsLoading(true)
            let pincodeDetails = await fetchPinCodeDetails(pincodeValue);
            if (pincodeDetails) {
                setIsLoading(false)
                if(pincodeDetails[0].PostOffice === null){
                    toast.error("Cannot find state and district for given pincode")
                }else{
                    setStateName(pincodeDetails[0].PostOffice[0].State);
                    setDistrict(pincodeDetails[0].PostOffice[0].District)
                }
            }
        }
    }
    const handleSavePersonalDetails = async(e) => {

        if(firstName ==="" || firstName === null){
            toast.error("Please enter your First Name")
            return
        }
        const pattern = /^[a-zA-Z0-9.a-zA-Z0-9.!#$%&'*+-/=?^_`{|}~]+@[a-zA-Z0-9]+\.[a-zA-Z]+/;
        if(!pattern.test(email)){
            toast.error("Email should like sample@example.com")
            return
        }
        setIsLoading(true);
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
        let sendBody = {
            "id" : userInfo?.user?.id,
            "name": `${firstName} ${lastName}`,
            "phoneNo": userInfo?.user?.phoneNo,
            "email": email,
            "pincode": pin,
            "state": state,
            "district": district,
            "address": house,
            "town": city,
            "accountType": "INDIVIDUAL_TRADER", 
            "active": true,
            "verified": true
        }
        try{
            const resp = await fireAjaxRequest(PUT_USER_DETAILS, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${userInfo.token}`
                },
                body: JSON.stringify(sendBody),
            });
            if(resp){
                setIsLoading(false);
                toast.success("Successfully Updated Details");
                setTimeout(() => {
                    window.location.reload(); 
                  }, 5000);
            }
        }catch(err){
            toast.error("Something went wrong. Please try again later")
        }
    }

    const toggleAnswer = (event) => {
        const questionDiv = event.currentTarget;
        const answerDiv = questionDiv.nextElementSibling;
      
        const answerDisplay = getComputedStyle(answerDiv).display;
        if (answerDisplay === 'none') {
          answerDiv.style.display = 'flex';
        } else {
          answerDiv.style.display = 'none';
        }
    }
    const handleHelpTabChange = (currentTab) =>{
        setActiveHelpTab(currentTab);
    }

    const getIndividualPanVerify = async(panNumbervalue)=>{
        if(accountTypeSelected === 'INDIVIDUAL_TRADER'){
            setIsLoading(true);
        }
        else if(accountTypeSelected === 'ORGANIZATION_TRADER'){
            setShowFirmNameRolling(true);
        }
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        try {
            const resp = await fireAjaxRequest(`${KYC_VERIFY_PAN}pan=${panNumbervalue}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${userInfo.token}`
                },  
            });
            if (resp && resp.data) {
                setIsLoading(false);
                setShowFirmNameRolling(false);
                setShowFirmNameTick(true);
                setSuccessfullyAddedKycPopup(true);
                setIndividualPanName(resp.data.name);
                if(accountTypeSelected==='INDIVIDUAL_TRADER')
                document.getElementsByClassName('panNameInput')[0].style.background="rgb(245, 245, 245)"
            } else {
                setIsLoading(false);
                setShowFirmNameRolling(false);
                setShowFirmNameTick(false);
                toast.error("Unable to fetch name linked to this PAN , Please try again")
            }
        } catch (err) {
            setIsLoading(false);
            if(err.code === "422"){
                setShowFirmNameRolling(false);
                toast.error("Invalid Details")
            }
            else{
                setShowFirmNameRolling(false);
                toast.error("something went wrong")
            }

        }
    }

    const handlePanNumber = async(e) =>{
        const inputValue = e.target.value.toUpperCase();
        setIndividualPanNumber(inputValue);
        if(inputValue.length===10){
            if(accountTypeSelected==='INDIVIDUAL_TRADER' && inputValue.charAt(3).toUpperCase()!=='P')
            {
                toast.error("PAN details provided belongs to an entity while the selection made above is Individual.Please select your Input above to Organization.");
                setIndividualPanNumber('');
            }
            else if(accountTypeSelected==='ORGANIZATION_TRADER' && inputValue.charAt(3).toUpperCase()==='P'){
                toast.error("PAN details provided belongs to an entity while the selection made above is Organization.Please select your Input above to Individual.");
                setIndividualPanNumber('');
            }
            else{
                const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
                const isValidPan = panPattern.test(inputValue);
                if(!isValidPan){
                    document.getElementsByClassName('panNumberError')[0].style.display="flex"
                }else{
                    document.getElementsByClassName('panNumberError')[0].style.display="none"
                    await getIndividualPanVerify(e.target.value.toUpperCase());
                }
            }
        }
        else if(inputValue.length===4){
            if(accountTypeSelected==='INDIVIDUAL_TRADER' && inputValue.charAt(3).toUpperCase()!=='P')
            {
                toast.error("PAN details provided belongs to an entity while the selection made above is Individual.Please select your Input above to Organization.");
                setIndividualPanNumber('');
            }
            else if(accountTypeSelected==='ORGANIZATION_TRADER' && inputValue.charAt(3).toUpperCase()==='P'){
                toast.error("PAN details provided belongs to an entity while the selection made above is Organization.Please select your Input above to Individual.");
                setIndividualPanNumber('');
            }
        }
        else{
            document.getElementsByClassName('panNameInput')[0].style.background="#FFF"
        }
    }

    const handlePanDOBChange = (date) => {
            setIndividualPanDOB(date);
      };

    const postPanKYC = async(updateName) =>{
        setIsLoading(true);
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
        var currentDob = new Date(individualPanDOB);
        var year = currentDob.getFullYear();
        var month = ("0" + (currentDob.getMonth() + 1)).slice(-2);
        var day = ("0" + currentDob.getDate()).slice(-2);
        var formattedDob = year + "-" + month + "-" + day;
        let sendBody = {
            "userId": userInfo?.user?.id,
            "type": "PAN",
            "value": individualPanNumber,
            "dob": formattedDob.toString(),
            "name": individualPanName
        }
        try {
            const resp = await fireAjaxRequest(`${POST_KYC_PROFILE}updateName=${updateName}&accountType=${accountTypeSelected}&isFromMobile=false`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${userInfo.token}`
                },
                body: JSON.stringify(sendBody),
            });
            if(resp){
                setIsLoading(false);
                getUserDetails();
            }
        } catch (err) {
            setIsLoading(false);
            if(err.code === "422"){
                toast.error("Invalid Details")
            }
            else{
                toast.error("something went wrong")
            }
        }
    }
    const postKYC = async(sendBody) =>{
        setIsLoading(true);
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
        try {
            const resp = await fireAjaxRequest(`${POST_KYC_PROFILE}updateName=NO&accountType=${accountTypeSelected}&isFromMobile=false`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${userInfo.token}`
                },
                body: JSON.stringify(sendBody),
            });
            if(resp){
                setIsLoading(false);
                setSelectedKYCItemFieldsPopup(false);
                setSuccessfullyAddedKycPopup(true);
                setItemToAddKycName('');
                setItemToAddKycValue('');
                setItemToAddKycAdharOtpValue('');
                setItemToAddKycDOB('');
                setItemToAddKycDateOfIssue('');
                setItemToAddKycFileNo('');
                setItemToAddKycIFSC('');
                getUserDetails();
            }
            else{
                setIsLoading(false);
                toast.error("Something Went Wrong : Try Again Later")
            }
        } catch (err) {
            setIsLoading(false);
            if(err.code === "422"){
                toast.error("Invalid Details")
            }
            else{
                toast.error("something went wrong")
            }
        }
    }

    const handleSavePANchanges = async() =>{
        if(individualPanName !== userPersonalDetails?.name){
            setShowDiffNamesPopup(true);
        }
        else{
            postPanKYC("NO");
        }
    }

    const OkClickForNameChange = async() =>{
        setShowDiffNamesPopup(false);
        postPanKYC("YES");
    }

    const handleAddIdBtn = () =>{
        setShowAddIdSelectPopup(!showAddIdSelectPopup); 
        setItemToAddKyc('');
    }
    const handleAddItemSubmit = () =>{
        if(itemToAddKyc !== ''){
            setShowAddIdSelectPopup(false);
            setSelectedKYCItemFieldsPopup(true);
        }
    }
    const clickEvent = (first, last) => {
        first.value = first.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        if (first.value.length) {
            if (last != 'seventh') {
            document.getElementById(last).focus();
            }
        }
        if (first.value.length < 1) {
            if (first.id == 'sixth') {
                document.getElementById('fifth').focus();
            }
            if (first.id == 'fifth') {
                document.getElementById('fourth').focus();
            }
            if (first.id == 'fourth') {
            document.getElementById('third').focus();
            }
            else if (first.id == 'third') {
            document.getElementById('sec').focus();
            }
            if (first.id == 'sec') {
            document.getElementById('ist').focus();
            }
        }
        // return true;
        }
    const _onChangeOTP = (e, position) => {
        const previousOTP = [...itemToAddKycAdharOtpValue];
        if (e && e.target && e.target.value) {
            previousOTP[position] = e.target.value || "";
        } else {
            previousOTP[position] = "";
        }
        setItemToAddKycAdharOtpValue([...previousOTP]);
    }

    const _onKeyDownOTP = (e, position) => {
        if (e.key === "Enter") {
            handleOtpverifyBtn();
        }
    }
    const handleAdditemKycSubmit = () =>{
        if(itemToAddKyc === "AADHAR" && !(itemToAddKycName === '' || itemToAddKycValue.length<12 || document.getElementById('file-name-input').value === '')){
            handleAadharSubmit();
        }
        else if(itemToAddKyc === "VOTER_ID"){
            var voterpattern = /^[A-Z]{3}\d{7}$/;
            if(itemToAddKycValue.length<10 || !voterpattern.test(itemToAddKycValue)){
                toast.error("Please enter valid Voter Id")
            }
            else{
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                let sendBody = {
                    "userId": userInfo?.user?.id,
                    "type": "VOTER_ID",
                    "value": itemToAddKycValue,
                }
                postKYC(sendBody);
            }
        }
        else if(itemToAddKyc === "DRIVING_LICENSE"){
            var DLpattern = /^[A-Z]{2}\d{13}$/;
            if(itemToAddKycValue.length<15 || !DLpattern.test(itemToAddKycValue)){
                toast.error("Please enter valid DL Number")
            }
            else{
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))

                var currentDob = new Date(itemToAddKycDOB);
                var year = currentDob.getFullYear();
                var month = ("0" + (currentDob.getMonth() + 1)).slice(-2);
                var day = ("0" + currentDob.getDate()).slice(-2);
                var formattedDate = year + "-" + month + "-" + day;

                let sendBody = {
                    "userId": userInfo?.user?.id,
                    "type": "DRIVING_LICENSE",
                    "value": itemToAddKycValue,
                    "dob": formattedDate.toString(),
                }
                postKYC(sendBody);
            }
        }
        else if(itemToAddKyc === "PASSPORT"){
            var PASSPORTpattern = /^[A-Z]{1}\d{7}$/;
            var fileNoPattern = /^[A-Z]{2}\d{13}$/
            if(itemToAddKycValue.length<8 || !PASSPORTpattern.test(itemToAddKycValue)){
                toast.error("Please enter valid Passport Number")
            }
            else if(!fileNoPattern.test(itemToAddKycFileNo)){
                toast.error("Please enter valid Passport Number")
            }
            else{
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                
                var currentDob = new Date(itemToAddKycDOB);
                var year = currentDob.getFullYear();
                var month = ("0" + (currentDob.getMonth() + 1)).slice(-2);
                var day = ("0" + currentDob.getDate()).slice(-2);
                var formattedDob = year + "-" + month + "-" + day;

                var currentDoi = new Date(itemToAddKycDateOfIssue);
                var year = currentDoi.getFullYear();
                var month = ("0" + (currentDoi.getMonth() + 1)).slice(-2);
                var day = ("0" + currentDoi.getDate()).slice(-2);
                var formattedDoi = day + "/" + month + "/" + year;

                let sendBody = {
                    "userId": userInfo?.user?.id,
                    "type": "PASSPORT",
                    "value": itemToAddKycValue,
                    "name": itemToAddKycName,
                    "dob":formattedDob.toString(),
                    "additionalProperties": {
                        "fileNumber": itemToAddKycFileNo,
                        "doi": formattedDoi.toString()
                    }
                }
                postKYC(sendBody);
            }
        }
        else if(itemToAddKyc === "BANK_ACCOUNT"){
            var Bankpattern =/^[0-9]+$/;
            var IFSCpattern = /^[A-Z]{4}\d{7}$/;
            if(!IFSCpattern.test(itemToAddKycIFSC)){
                toast.error("Please enter valid IFSC Code")
            }
            else if(!Bankpattern.test(itemToAddKycValue)){
                toast.error("Please enter valid Account Number")
            }
            else if(itemToAddKycValue.length<9){
                toast.error("Account Number should be in Miniumum 9 digits")
            }
            else{
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                let sendBody = {
                    "userId": userInfo?.user?.id,
                    "type": "BANK_ACCOUNT",
                    "value": itemToAddKycValue,
                    "additionalProperties": {
                        "ifscCode": itemToAddKycIFSC
                    }
                }
                postKYC(sendBody);
            }
        }
        else if(itemToAddKyc === "UDYOG_AADHAR"){
            var udyogpattern = /^[A-Z]{2}[0-9]{2}[A-Z]{1}[0-9]{7}$/;
            if(!udyogpattern.test(itemToAddKycValue)){
                toast.error("Please enter valid Udyog Aadhaar Number")
            }
            else{
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                let sendBody = {
                    "userId": userInfo?.user?.id,
                    "type": "UDYOG_AADHAR",
                    "value": itemToAddKycValue,
                }
                postKYC(sendBody);
            }
        }
        else if(itemToAddKyc === "GSTIN_NUMBER"){
            var panObject = userPersonalDetails.kyc.find(function(item) {
                return item.type === "PAN";
              });
            var GSTpattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
            if(!GSTpattern.test(itemToAddKycValue)){
                toast.error("Please enter valid GST Number")
            }
            else if(!(itemToAddKycValue.substring(2,12)===panObject.value)){
                toast.error("Please enter valid GST Number linked with the registred PAN")
            }
            else{
                let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
                let sendBody = {
                    "userId": userInfo?.user?.id,
                    "type": "GSTIN_NUMBER",
                    "value": itemToAddKycValue,
                }
                postKYC(sendBody);
            }
        }
    }
    const handleAadharSubmit = () =>{
        setIsLoading(true);
        var bodyFormData = new FormData();
        bodyFormData.append('file', adharFileZip);
        bodyFormData.append('consent', "Y");
        bodyFormData.append('shareCode', aadharShareCode);
        bodyFormData.append('userId', userPersonalDetails.id)
        Axios({
            url: `${AADHAAR_OFFLINE_API}?updatePersonalInfo=NO`,
            method: 'POST',
            data: bodyFormData,
            headers: {
                "Authorization": `Bearer ${JSON.parse(sessionStorage.getItem("userInfo")).token}`,
                "Content-Type": "multipart/formdata"
            },
        }).then((resp) => {
            setIsLoading(false);
            if (resp && resp.data && resp.data.data) {
                getUserDetails();
                setSelectedKYCItemFieldsPopup(false);   
                setItemToAddKycName('');
                setItemToAddKycValue('');
                setAdharFileZip(null);
                setAadharAccessKey('');
                setAadharShareCode('');
                setItemToAddKycAdharOtpValue([]);
                setShowUploadAdhar(false);
                setSuccessfullyAddedKycPopup(true);
            }
        })
        .catch(error => {
            setIsLoading(false);
            if(error.code === "422"){
                toast.error("Invalid Details")
            }
            else{
                toast.error("something went wrong")
            }
        })
    }
    const handleAdditemKycCross =() =>{
        setSelectedKYCItemFieldsPopup(false);
        setItemToAddKycName('');
        setItemToAddKycValue('');
        setItemToAddKycAdharOtpValue('');
        setItemToAddKycDOB('');
        setItemToAddKycDateOfIssue('');
        setItemToAddKycFileNo('');
        setItemToAddKycIFSC('');
    }
    const handleAdharOtpPopupCross = () =>{
        setItemToAddKycOtpPopup(false);
        setItemToAddKycAdharOtpValue('');
    }
    const handleSuccessfullyAddedKycPopupCross = () =>{
        setSuccessfullyAddedKycPopup(false);
        setItemToAddKycName('');
        setItemToAddKycValue('');
        setItemToAddKycAdharOtpValue('');
        setItemToAddKycDOB('');
        setItemToAddKycDateOfIssue('');
        setItemToAddKycFileNo('');
        setItemToAddKycIFSC('');
    }
    const handleAadharConsentPopupCross = () =>{
       setShowAdharConsentPopup(false);
    }
    const handleOtpverifyBtn = () =>{
        if(itemToAddKycAdharOtpValue.length===6){
            handleVarifyOtp();
            setItemToAddKycOtpPopup(false);
        }
    }
    const handleVarifyOtp = () =>{
        setIsLoading(true);
        const verifyOTPDetails = {
            "otp":  itemToAddKycAdharOtpValue.join(""),
            "shareCode": aadharShareCode,
            "accessKey": aadharAccessKey,
            "aadhaarNo": itemToAddKycValue,
            "clientData": {
                "caseId": "a341fafb"
            }
        };
        (async () => {
            try {
                const resp = await fireAjaxRequest(GET_AADHAAR_API, {
                    method: 'POST',
                    headers: {
                        "Authorization": `Bearer ${JSON.parse(sessionStorage.getItem("userInfo")).token}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(verifyOTPDetails)
                });
                if (resp && resp.data && resp.data.dataFromAadhaar) {
                    setIsLoading(false);
                    downloadZip("aadhaar.zip", resp.data.dataFromAadhaar.file);
                    setItemToAddKycOtpPopup(false);
                    setShowUploadAdhar(true);
                }
                else{
                    toast.error("Something Went Wrong..Please try again later.")
                }
            } catch (err) {
                setIsLoading(false);
                if(err.code === "422"){
                toast.error("Invalid OTP")
                }
                else{
                    toast.error("something went wrong")
                }
            }
        })();
    }
    const handleAddAnotherKyc =()=>{
        setSuccessfullyAddedKycPopup(false);
        setShowAddIdSelectPopup(true);
        setItemToAddKycName('');
        setItemToAddKycValue('');
        setItemToAddKycAdharOtpValue('');
        setItemToAddKycDOB('');
        setItemToAddKycDateOfIssue('');
        setItemToAddKycFileNo('');
        setItemToAddKycIFSC('');
    }
    const handleAdharNumberChange = (e) =>{
        if(itemToAddKyc === "AADHAR" && e.target.value.length===12 && itemToAddKycName !==''){
            getAdharOtp(e.target.value);
        }
        else if(itemToAddKyc === "AADHAR" && e.target.value.length===12 && itemToAddKycName ===''){
            toast.error("Name should not be empty , Please enter your name first and then aadhar number")
            setItemToAddKycName('');
            setItemToAddKycValue('');
        }
    }
    const getAdharOtp = (value) =>{
        setIsLoading(true)
        const browser = detect();
        const sendDetails = {
            "value": value,
            "userAgent": browser.name,
            "consent": "Y",
            "name": itemToAddKycName,
            "consentText": "I hereby grant consent to..",
            "consentTime": "1610369914",
            "ipAddress": "192.168.43.96",
            "lat": "17.300166",
            "longitude": "78.526495",
            "clientData": {
                "caseId": "a341fafb"
            },
            "deviceId": "5FA01EE3-B9AB-42A3-ACB1-B150D0C2CA07"
        };
        (async () => {
            try {
                const resp = await fireAjaxRequest(AADHAAR_CONSENT_API, {
                    method: 'POST',
                    headers: {
                        "Authorization": `Bearer ${JSON.parse(sessionStorage.getItem("userInfo")).token}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(sendDetails)
                });
                if (resp && resp.data) {
                    setIsLoading(false);
                    setItemToAddKycOtpPopup(true);
                    setItemToAddKycAdharOtpValue([])
                    setCounter(60);
                    setAadharAccessKey(resp.data.result.accessKey)
                    setAadharShareCode(resp.shareCode)
                    if (resp.message.includes("not")) {
                        toast.error(resp.message);
                    }
                }
                else if (resp) {
                    setIsLoading(false);
                    toast.error("Something Went Wrong, Please Try Again Later or Make sure your entered deatils are correct.")
                }
            } catch (err) {
                setIsLoading(false);
                if(err.code === "422"){
                    toast.error("Invalid Details")
                    }
                    else{
                        toast.error("something went wrong")
                    }
            }
        })();
    }
    const downloadZip = (filename, data) => {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;base64,' + data);
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();
        document.body.removeChild(element);
    }
    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        const fileNameInput = document.getElementById('file-name-input');
    
        if (file) {
          fileNameInput.value = file.name;
          setAdharFileZip(file);
        }
      };
    const handleFileInputClick = () => {
        fileInputRef.current.click();
    };
    const handleResendOtp = () =>{
        getAdharOtp(itemToAddKycValue);
    }
    const handleCheckboxChange = (e) => {
        setIsCheckedAadharConsent(!isCheckedAadharConsent);
    }
    const handleShowAadharConsent = (e) =>{
        setShowAdharConsentPopup(true);
    }
  return (
    <div class="mainContainer">
        <div class="innerContainer postInnerContainer">
            <div class="chatOverlay">
                <div class="toaster">
                    Phone number copied successfully!
                </div>
                <div class="loginContainer">
                    <div class="loginLeft">
                        <svg width="85" height="33" viewBox="0 0 85 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M39.9681 5.00335C39.9681 5.73383 39.8752 6.3983 39.6895 6.99676C39.5038 7.58643 39.2252 8.09688 38.8538 8.52813C38.4913 8.95938 38.0358 9.28941 37.4876 9.51824C36.9481 9.74706 36.3203 9.86148 35.604 9.86148C34.8611 9.86148 34.2156 9.74706 33.6673 9.51824C33.119 9.28061 32.6636 8.95058 32.301 8.52813C31.9384 8.09688 31.6687 7.58203 31.4919 6.98356C31.315 6.3851 31.2266 5.72062 31.2266 4.99014C31.2266 4.02204 31.3857 3.17715 31.7041 2.45547C32.0225 1.73379 32.5044 1.17053 33.15 0.765684C33.8044 0.36084 34.6268 0.158418 35.6172 0.158418C36.5634 0.158418 37.3593 0.36084 38.0049 0.765684C38.6504 1.16173 39.1368 1.72499 39.464 2.45547C39.8001 3.17715 39.9681 4.02644 39.9681 5.00335ZM32.4867 5.00335C32.4867 5.79543 32.5973 6.47751 32.8183 7.04957C33.0394 7.62163 33.3799 8.06168 33.8397 8.36971C34.3084 8.67775 34.8965 8.83177 35.604 8.83177C36.3203 8.83177 36.9039 8.67775 37.3549 8.36971C37.8148 8.06168 38.1552 7.62163 38.3763 7.04957C38.5974 6.47751 38.7079 5.79543 38.7079 5.00335C38.7079 3.81522 38.4603 2.88672 37.9651 2.21784C37.4699 1.54017 36.6872 1.20133 35.6172 1.20133C34.9009 1.20133 34.3084 1.35535 33.8397 1.66338C33.3799 1.96261 33.0394 2.39826 32.8183 2.97032C32.5973 3.53359 32.4867 4.21126 32.4867 5.00335Z"
                                fill="#0B0B0B" />
                            <path
                                d="M47.4351 2.52148C47.5677 2.52148 47.7092 2.53028 47.8595 2.54788C48.0187 2.55668 48.1558 2.57428 48.2707 2.60068L48.1248 3.67C48.0099 3.6436 47.8816 3.6216 47.7402 3.60399C47.6075 3.58639 47.4793 3.57759 47.3555 3.57759C47.0813 3.57759 46.8205 3.6348 46.5728 3.74921C46.3252 3.86362 46.1042 4.02644 45.9096 4.23766C45.7151 4.44008 45.5603 4.68651 45.4453 4.97694C45.3392 5.26737 45.2862 5.59301 45.2862 5.95385V9.72946H44.1189V2.65349H45.0739L45.2066 3.94723H45.2596C45.41 3.6832 45.5913 3.44558 45.8035 3.23435C46.0157 3.01433 46.2589 2.84271 46.5331 2.7195C46.8072 2.58748 47.1079 2.52148 47.4351 2.52148Z"
                                fill="#0B0B0B" />
                            <path
                                d="M52.9765 2.65349V9.72946H51.8092V2.65349H52.9765ZM52.4061 0C52.5829 0 52.7377 0.0616067 52.8704 0.18482C53.0118 0.299233 53.0826 0.484053 53.0826 0.739281C53.0826 0.985707 53.0118 1.17053 52.8704 1.29374C52.7377 1.41695 52.5829 1.47856 52.4061 1.47856C52.2115 1.47856 52.0479 1.41695 51.9153 1.29374C51.7826 1.17053 51.7163 0.985707 51.7163 0.739281C51.7163 0.484053 51.7826 0.299233 51.9153 0.18482C52.0479 0.0616067 52.2115 0 52.4061 0Z"
                                fill="#0B0B0B" />
                            <path
                                d="M59.9601 2.52148C60.4288 2.52148 60.8489 2.60949 61.2203 2.7855C61.6005 2.96152 61.9233 3.22995 62.1886 3.59079H62.2549L62.4141 2.65349H63.3427V9.84828C63.3427 10.5171 63.2277 11.076 62.9978 11.5249C62.7678 11.9825 62.4185 12.3257 61.9498 12.5546C61.4812 12.7834 60.8842 12.8978 60.1591 12.8978C59.6462 12.8978 59.1731 12.8582 58.7398 12.779C58.3153 12.7086 57.935 12.5986 57.599 12.449V11.3796C57.8289 11.4941 58.0809 11.5909 58.3551 11.6701C58.6292 11.7581 58.9255 11.8241 59.2438 11.8681C59.5622 11.9121 59.8894 11.9341 60.2254 11.9341C60.8356 11.9341 61.3131 11.7537 61.658 11.3928C62.0117 11.0408 62.1886 10.5568 62.1886 9.94069V9.66346C62.1886 9.55784 62.193 9.40823 62.2019 9.21461C62.2107 9.01218 62.2196 8.87137 62.2284 8.79216H62.1753C61.9277 9.153 61.6182 9.42143 61.2468 9.59745C60.8842 9.77347 60.4598 9.86148 59.9734 9.86148C59.0537 9.86148 58.333 9.54024 57.8112 8.89777C57.2983 8.2553 57.0419 7.3576 57.0419 6.20468C57.0419 5.44779 57.1568 4.79652 57.3867 4.25086C57.6255 3.6964 57.9616 3.26956 58.3949 2.97032C58.8282 2.67109 59.3499 2.52148 59.9601 2.52148ZM60.1193 3.49838C59.7214 3.49838 59.3809 3.60399 59.0979 3.81522C58.8238 4.02644 58.6115 4.33447 58.4612 4.73932C58.3197 5.14416 58.249 5.63702 58.249 6.21788C58.249 7.08917 58.4081 7.75805 58.7265 8.2245C59.0537 8.68215 59.5268 8.91097 60.1458 8.91097C60.5084 8.91097 60.8179 8.86697 61.0744 8.77896C61.3308 8.68215 61.5431 8.53693 61.7111 8.34331C61.8791 8.14089 62.0029 7.88566 62.0825 7.57763C62.1621 7.26959 62.2019 6.90435 62.2019 6.48191V6.20468C62.2019 5.56221 62.1267 5.04295 61.9764 4.64691C61.8349 4.25086 61.6094 3.96043 61.2999 3.77561C60.9904 3.59079 60.5968 3.49838 60.1193 3.49838Z"
                                fill="#0B0B0B" />
                            <path
                                d="M73.993 6.17827C73.993 6.76794 73.9134 7.2916 73.7542 7.74925C73.6039 8.1981 73.3828 8.58094 73.091 8.89777C72.808 9.21461 72.4587 9.45663 72.0431 9.62385C71.6363 9.78227 71.1808 9.86148 70.6768 9.86148C70.2081 9.86148 69.7748 9.78227 69.3768 9.62385C68.9789 9.45663 68.634 9.21461 68.3422 8.89777C68.0503 8.58094 67.8204 8.1981 67.6524 7.74925C67.4932 7.2916 67.4136 6.76794 67.4136 6.17827C67.4136 5.39499 67.5463 4.73492 67.8116 4.19806C68.0769 3.6524 68.4571 3.23875 68.9524 2.95712C69.4476 2.66669 70.0356 2.52148 70.7166 2.52148C71.3621 2.52148 71.9281 2.66669 72.4145 2.95712C72.9097 3.23875 73.2944 3.6524 73.5685 4.19806C73.8515 4.73492 73.993 5.39499 73.993 6.17827ZM68.6207 6.17827C68.6207 6.73274 68.6915 7.21679 68.833 7.63043C68.9833 8.03528 69.2132 8.34771 69.5227 8.56774C69.8323 8.78776 70.2258 8.89777 70.7033 8.89777C71.1808 8.89777 71.5744 8.78776 71.8839 8.56774C72.1934 8.34771 72.4189 8.03528 72.5604 7.63043C72.7107 7.21679 72.7859 6.73274 72.7859 6.17827C72.7859 5.61501 72.7107 5.13536 72.5604 4.73932C72.4101 4.34327 72.1801 4.03964 71.8706 3.82842C71.5699 3.60839 71.1764 3.49838 70.69 3.49838C69.9649 3.49838 69.4387 3.73601 69.1115 4.21126C68.7843 4.68651 68.6207 5.34218 68.6207 6.17827Z"
                                fill="#0B0B0B" />
                            <path
                                d="M16.5181 30.4931V13.3503H21.7694L24.9226 25.0439L28.0402 13.3503H33.3035V30.4931H30.0436V16.9987L26.594 30.4931H23.2156L19.7779 16.9987V30.4931H16.5181Z"
                                fill="#0B0B0B" />
                            <path
                                d="M39.4749 21.8632L36.4521 21.3253C36.7919 20.1248 37.3767 19.2361 38.2065 18.6592C39.0363 18.0823 40.2691 17.7939 41.905 17.7939C43.3907 17.7939 44.4971 17.9693 45.2242 18.3201C45.9512 18.6631 46.4609 19.1036 46.7533 19.6415C47.0536 20.1716 47.2038 21.1499 47.2038 22.5765L47.1682 26.412C47.1682 27.5034 47.2196 28.3103 47.3223 28.8326C47.433 29.3471 47.6345 29.9006 47.9269 30.4931H44.6315C44.5445 30.2748 44.4378 29.9513 44.3114 29.5225C44.2561 29.3276 44.2166 29.199 44.1929 29.1366C43.6239 29.6823 43.0153 30.0916 42.3673 30.3644C41.7193 30.6373 41.0278 30.7737 40.2929 30.7737C38.9968 30.7737 37.9734 30.4268 37.2226 29.733C36.4798 29.0392 36.1084 28.1621 36.1084 27.1019C36.1084 26.4003 36.2783 25.7767 36.6181 25.231C36.9579 24.6775 37.4321 24.2565 38.0406 23.9681C38.657 23.6718 39.5421 23.4146 40.6959 23.1963C42.2527 22.9079 43.3315 22.6389 43.9321 22.3894V22.062C43.9321 21.4306 43.774 20.9823 43.4579 20.7173C43.1418 20.4444 42.5451 20.308 41.6679 20.308C41.0752 20.308 40.6129 20.4249 40.281 20.6588C39.9491 20.8849 39.6804 21.2863 39.4749 21.8632ZM43.9321 24.5294C43.5053 24.6697 42.8296 24.8373 41.905 25.0322C40.9804 25.2271 40.3758 25.4181 40.0913 25.6052C39.6567 25.9092 39.4394 26.2951 39.4394 26.7628C39.4394 27.2228 39.6132 27.6203 39.9609 27.9556C40.3087 28.2908 40.7512 28.4584 41.2886 28.4584C41.8892 28.4584 42.4622 28.2635 43.0074 27.8737C43.4105 27.5775 43.6752 27.215 43.8017 26.7862C43.8886 26.5056 43.9321 25.9716 43.9321 25.1842V24.5294Z"
                                fill="#0B0B0B" />
                            <path
                                d="M62.171 30.4931H58.84V24.1552C58.84 22.8143 58.7689 21.949 58.6266 21.5592C58.4844 21.1616 58.2512 20.8537 57.9272 20.6354C57.6111 20.4171 57.2278 20.308 56.7774 20.308C56.2005 20.308 55.6828 20.4639 55.2245 20.7757C54.7661 21.0876 54.45 21.5007 54.2762 22.0152C54.1102 22.5298 54.0272 23.4808 54.0272 24.8685V30.4931H50.6962V18.0745H53.7901V19.8987C54.8886 18.4955 56.2716 17.7939 57.9391 17.7939C58.674 17.7939 59.3458 17.9264 59.9543 18.1915C60.5628 18.4487 61.0211 18.78 61.3293 19.1854C61.6455 19.5908 61.8628 20.0507 61.9813 20.5652C62.1078 21.0798 62.171 21.8165 62.171 22.7753V30.4931Z"
                                fill="#0B0B0B" />
                            <path
                                d="M77.3278 30.4931H74.2339V28.6689C73.7203 29.3783 73.1117 29.9084 72.4084 30.2592C71.713 30.6022 71.0096 30.7737 70.2984 30.7737C68.8522 30.7737 67.6114 30.2007 66.5762 29.0548C65.5488 27.901 65.0352 26.2951 65.0352 24.237C65.0352 22.1322 65.537 20.5341 66.5406 19.4427C67.5443 18.3435 68.8127 17.7939 70.3458 17.7939C71.7525 17.7939 72.9695 18.3708 73.9968 19.5245V13.3503H77.3278V30.4931ZM68.4373 24.0148C68.4373 25.3401 68.623 26.299 68.9944 26.8914C69.5318 27.749 70.2826 28.1777 71.2467 28.1777C72.0133 28.1777 72.6652 27.8581 73.2026 27.2189C73.74 26.5718 74.0087 25.6091 74.0087 24.3306C74.0087 22.904 73.7479 21.8788 73.2263 21.2552C72.7048 20.6237 72.037 20.308 71.223 20.308C70.4327 20.308 69.7689 20.6198 69.2315 21.2435C68.702 21.8593 68.4373 22.7831 68.4373 24.0148Z"
                                fill="#0B0B0B" />
                            <path
                                d="M80.844 16.3907V13.3503H84.175V16.3907H80.844ZM80.844 30.4931V18.0745H84.175V30.4931H80.844Z"
                                fill="#0B0B0B" />
                            <path
                                d="M11.5401 21.8275C11.5401 22.1802 11.4327 22.5887 11.2178 23.0531C11.0029 23.5089 10.6075 23.9949 10.0315 24.5109C9.46421 25.0269 8.64759 25.4827 7.58168 25.8783C6.52437 26.274 5.19199 26.5449 3.58454 26.6911L3.27508 26.7169C3.20631 27.0609 3.17193 27.3791 3.17193 27.6715C3.17193 28.308 3.32236 28.7681 3.62322 29.0519C3.93268 29.3271 4.37967 29.4647 4.9642 29.4647C6.2536 29.4647 7.48713 28.7681 8.66478 27.3748H10.0315C9.49859 28.1919 8.69057 29.0003 7.60747 29.8001C6.52437 30.6 5.23927 30.9999 3.75216 30.9999C2.72064 30.9999 1.83525 30.7247 1.09599 30.1743C0.36533 29.6152 0 28.7982 0 27.7231C0 26.4073 0.36533 25.1301 1.09599 23.8916C1.82665 22.6446 2.82379 21.634 4.0874 20.86C5.35102 20.0774 6.72638 19.686 8.21349 19.686C9.40833 19.686 10.2593 19.8881 10.7665 20.2924C11.2823 20.6966 11.5401 21.2083 11.5401 21.8275ZM8.81951 21.7759C8.81951 21.4921 8.72065 21.2341 8.52295 21.0019C8.32524 20.7611 8.05446 20.6407 7.71062 20.6407C7.1089 20.6407 6.55446 20.8514 6.04729 21.2728C5.54873 21.6856 5.12752 22.1759 4.78368 22.7435C4.43984 23.3111 4.15617 23.8873 3.93268 24.4722C3.71777 25.057 3.58454 25.4182 3.53296 25.5558C5.27795 25.2634 6.59314 24.7689 7.47853 24.0723C8.37251 23.3756 8.81951 22.6102 8.81951 21.7759Z"
                                fill="#04B23D" />
                        </svg>
                        <p>Join the <span>revolution</span></p>
                        <p>Join the <span>Origo</span> Community</p>
                        <img src={people} alt=""/>
                    </div>

                    <div class="loginRight chatRight">
                        <div>
                            <svg width="14" height="13" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0.499999 4.99993C0.503649 4.60535 0.662633 4.2281 0.942499 3.94993L4.16 0.724931C4.30052 0.585242 4.49061 0.506836 4.68875 0.506836C4.88689 0.506836 5.07698 0.585242 5.2175 0.724931C5.2878 0.794653 5.34359 0.877604 5.38167 0.968998C5.41974 1.06039 5.43935 1.15842 5.43935 1.25743C5.43935 1.35644 5.41974 1.45447 5.38167 1.54586C5.34359 1.63726 5.2878 1.72021 5.2175 1.78993L2.75 4.24993H10.25C10.4489 4.24993 10.6397 4.32895 10.7803 4.4696C10.921 4.61025 11 4.80102 11 4.99993C11 5.19884 10.921 5.38961 10.7803 5.53026C10.6397 5.67091 10.4489 5.74993 10.25 5.74993H2.75L5.2175 8.21743C5.35873 8.35767 5.43846 8.54826 5.43917 8.74728C5.43987 8.9463 5.36148 9.13745 5.22125 9.27868C5.08102 9.41991 4.89042 9.49965 4.6914 9.50035C4.49238 9.50105 4.30123 9.42266 4.16 9.28243L0.942499 6.05743C0.660809 5.77742 0.501674 5.39711 0.499999 4.99993Z"
                                    fill="#545050" />
                            </svg>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.8045 0.195191C15.6795 0.0702103 15.51 0 15.3332 0C15.1564 0 14.9869 0.0702103 14.8619 0.195191L7.99986 7.05719L1.13786 0.195191C1.01284 0.0702103 0.8433 0 0.666524 0C0.489748 0 0.320209 0.0702103 0.195191 0.195191C0.0702103 0.320209 0 0.489748 0 0.666524C0 0.8433 0.0702103 1.01284 0.195191 1.13786L7.05719 7.99986L0.195191 14.8619C0.0702103 14.9869 0 15.1564 0 15.3332C0 15.51 0.0702103 15.6795 0.195191 15.8045C0.320209 15.9295 0.489748 15.9997 0.666524 15.9997C0.8433 15.9997 1.01284 15.9295 1.13786 15.8045L7.99986 8.94252L14.8619 15.8045C14.9869 15.9295 15.1564 15.9997 15.3332 15.9997C15.51 15.9997 15.6795 15.9295 15.8045 15.8045C15.9295 15.6795 15.9997 15.51 15.9997 15.3332C15.9997 15.1564 15.9295 14.9869 15.8045 14.8619L8.94252 7.99986L15.8045 1.13786C15.9295 1.01284 15.9997 0.8433 15.9997 0.666524C15.9997 0.489748 15.9295 0.320209 15.8045 0.195191Z"
                                    fill="#757575" />
                            </svg>
                        </div>
                        <div class="chatContent">
                            <p>Call Us here:</p>
                            <div onClick={()=>{navigator.clipboard.writeText('+91 8338047777')}} onPointerDown={()=>{navigator.clipboard.writeText('+91 8338047777')}}>
                                <span>+91 8338047777</span>
                                <svg width="14" height="16" viewBox="0 0 14 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.66665 13.3333C8.55038 13.3323 9.39761 12.9808 10.0225 12.3559C10.6474 11.731 10.9989 10.8837 11 10V4.16201C11.001 3.81158 10.9325 3.46444 10.7984 3.14069C10.6642 2.81694 10.4672 2.52304 10.2186 2.27601L8.72398 0.781345C8.47695 0.532794 8.18305 0.335747 7.8593 0.201625C7.53555 0.0675032 7.18841 -0.0010253 6.83798 1.15931e-05H3.66665C2.78292 0.00107016 1.93568 0.3526 1.31079 0.977491C0.685901 1.60238 0.334372 2.44961 0.333313 3.33334V10C0.334372 10.8837 0.685901 11.731 1.31079 12.3559C1.93568 12.9808 2.78292 13.3323 3.66665 13.3333H7.66665ZM1.66665 10V3.33334C1.66665 2.80291 1.87736 2.2942 2.25243 1.91913C2.62751 1.54406 3.13621 1.33334 3.66665 1.33334C3.66665 1.33334 6.94598 1.34268 6.99998 1.34934V2.66668C6.99998 3.0203 7.14046 3.35944 7.3905 3.60949C7.64055 3.85954 7.97969 4.00001 8.33331 4.00001H9.65065C9.65731 4.05401 9.66665 10 9.66665 10C9.66665 10.5304 9.45593 11.0392 9.08086 11.4142C8.70579 11.7893 8.19708 12 7.66665 12H3.66665C3.13621 12 2.62751 11.7893 2.25243 11.4142C1.87736 11.0392 1.66665 10.5304 1.66665 10ZM13.6666 5.33334V12.6667C13.6656 13.5504 13.3141 14.3976 12.6892 15.0225C12.0643 15.6474 11.217 15.999 10.3333 16H4.33331C4.1565 16 3.98693 15.9298 3.86191 15.8047C3.73688 15.6797 3.66665 15.5102 3.66665 15.3333C3.66665 15.1565 3.73688 14.987 3.86191 14.8619C3.98693 14.7369 4.1565 14.6667 4.33331 14.6667H10.3333C10.8637 14.6667 11.3725 14.456 11.7475 14.0809C12.1226 13.7058 12.3333 13.1971 12.3333 12.6667V5.33334C12.3333 5.15653 12.4035 4.98696 12.5286 4.86194C12.6536 4.73692 12.8232 4.66668 13 4.66668C13.1768 4.66668 13.3464 4.73692 13.4714 4.86194C13.5964 4.98696 13.6666 5.15653 13.6666 5.33334Z"
                                        fill="#757575" />
                                </svg>
                            </div>
                            <div>
                                <span>Or Scan:</span>
                                <img src={scanner} style={{cursor: "pointer"}} onclick="window.open('https://wa.me/message/MAJZQZV5VM7DD1?src=qr')" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Popup open={showDiffNamesPopup} className="diffNameKycPersonal-popup" closeOnDocumentClick={false}> 
                <div className='modal-header diffNamesPopup-header'>
                    Different Names!!
                </div>
                <div className="modal-content">
                    <p className='diffNamesPopup-para'>The name you entered in the personal info and the name in the KYC does not match. The name will be updated in the personal info as per the KYC.</p>
                    <div className='diffNamesPopup-okBtn-conatiner'>
                        <button 
                            onClick={()=>{
                                OkClickForNameChange();
                            }}
                            className='diffNamesPopup-okBtn'
                        >Ok</button>
                    </div>
                </div>
            </Popup>
            {isLoading && <div id="loader-container">
                <div id="spinner"></div>
            </div>}
            
            <Navbar />
            <div className='profileSectionFixedTop'>
                <div className='eresearch-breadcrumbs'>
                    <img src={backArrowEResearch} onClick={()=>{history.push('/postreg')}}></img>
                    <div className='breads' onClick={()=>{history.push('/postreg')}}>
                        Home &gt; &nbsp;
                        <span style={{color: "#04B23D"}} onClick={(e)=>{e.stopPropagation(); history.push('/profile')}}>Profile</span>
                    </div>
                </div>
                <div className='nameContainer'> 
                    <div className='FirstLetterDiv'>{userPersonalDetails && userPersonalDetails?.name.charAt(0)}</div>
                    <span className='fullName'>{userPersonalDetails && userPersonalDetails?.name}</span>
                </div>
                <div className='profile-tabs-container'>
                    <div className="profile-tabs">
                        <div
                            className={`profile-tab ${activeTab === 'personal' ? 'active-profile-tab' : ''}`}
                            onClick={() => handleTabClick('personal')}
                        >
                        <span>Account </span><span className='hideOnMobile'>Details</span> 
                        </div>
                        <div
                            className={`profile-tab ${activeTab === 'kyc' ? 'active-profile-tab' : ''}`}
                            onClick={() => handleTabClick('kyc')}
                        >
                        <span>KYC </span><span className='hideOnMobile'>Information</span>  
                        </div>
                        <div
                            className={`profile-tab ${activeTab === 'help' ? 'active-profile-tab' : ''}`}
                            onClick={() => handleTabClick('help')}
                        >
                        <span>Help </span><span className='hideOnMobile'>Center</span>   
                        </div>
                    </div>
                </div>
            </div>
            
            <Scrollbars autoHide={false} style={{ width: "100%", height: "70vh" }} className="scrollbars-wrapper">

            { activeTab === "personal" && 
                <div className='personal-div'>
                    <div className='personal-form-container'>
                        <div className='form-rows'>
                            <span className='form-labels'>First Name</span>
                            <input 
                            placeholder='First Name' 
                            className='form-inputs name-form-input'
                            value={firstName} 
                            disabled
                            onChange={(e)=>{
                                const inputValue = e.target.value;
                                const pattern = /^[A-Za-z\s]*$/; 
                                if (pattern.test(inputValue)) {
                                setFirstName(inputValue);
                                }
                            }}>
                            </input>
                        </div>
                        <div className='form-rows'>
                            <span className='form-labels'>Last Name</span>
                            <input 
                            placeholder='Last Name' 
                            className='form-inputs name-form-input' 
                            value={lastName} 
                            disabled
                            onChange={(e)=>{
                                const inputValue = e.target.value;
                                const pattern = /^[A-Za-z\s]*$/; 
                                if (pattern.test(inputValue)) {
                                    setLastName(inputValue);
                                }
                            }}>
                            </input>
                        </div>
                        <div className='form-rows'>
                            <span className='form-labels'>Phone Number</span>
                            <div className='phone-container'>
                                <div className='country-code-div'>
                                    <span className='country-code'>+91</span>
                                    <img src={downArrowLight} className='downArrowLight'></img>
                                </div>
                                <input placeholder='Phone Number' className='form-phone-inputs' value={phoneNumber} disabled></input>
                            </div>
                            {/* <input placeholder='Phone Number' className='form-inputs' value={phoneNumber} disabled></input> */}
                        </div>
                        <div className='form-rows'>
                            <span className='form-labels'>Email ID</span>
                            <input 
                            placeholder='Email Address' 
                            className='form-inputs' 
                            value={email} 
                            onChange={(e)=>{
                                setEmail(e.target.value);
                            }}>
                            </input>
                        </div>
                        <div className='form-rows form-address-row'>
                            <span className='form-labels form-address-label'>Address</span>
                            <div className='form-Address-inputs-container'> 
                                <div className='form-address-pin-state-container'>
                                    <input placeholder='Pincode' className='form-address-input' value={pin} onChange={handlePincodeChange} maxlength="6"></input>
                                    <input placeholder='State' className='form-address-input' value={state} disabled style={{background: "#F5F5F5"}}></input>
                                </div>
                                <input placeholder='House No. , Building, Street, Area' className='form-address-input' value={house} onChange={(e)=>{setHouse(e.target.value)}}></input>
                                <input placeholder='City' className='form-address-input' value={city} 
                                onChange={(e)=>{
                                    const inputValue = e.target.value;
                                    const pattern = /^[A-Za-z\s]*$/; 
                                    if (pattern.test(inputValue)) {
                                        setCity(e.target.value)
                                    }
                                }}
                                ></input>
                                <input placeholder='District' className='form-address-input' value={district} disabled style={{background: "#F5F5F5"}}></input>
                            </div>
                        </div>
                        <div className="personal-detail-btn-container">
                            <button className='personal-details-submit-btn' onClick={handleSavePersonalDetails}>Save Changes</button>
                        </div>
                    </div>
                    
                </div>
            }
            { activeTab === "kyc" &&
                <div className='kyc-div'>
                    <div className={`radio-group account-type-container ${userPersonalDetails.kyc.length > 0 ? 'kyc-completed' : ''}`}>
                        <input 
                        type="radio" 
                        id="radio1"
                        name="radio" 
                        value="INDIVIDUAL_TRADER" 
                        checked={accountTypeSelected === "INDIVIDUAL_TRADER"} 
                        onClick={()=>{
                            if(userPersonalDetails.kyc.length <= 0){
                                setAccountTypeSelected('INDIVIDUAL_TRADER')
                                setIndividualPanNumber('');
                                setIndividualPanDOB('');
                                setIndividualPanName('');
                                setShowFirmNameTick(false);
                                setShowFirmNameRolling(false)
                            }
                        }} 
                        disabled={userPersonalDetails.kyc.length>0}
                        />
                        <label for="radio1">Individual</label>
                        <input 
                        type="radio" 
                        id="radio2" 
                        name="radio" 
                        value="ORGANIZATION_TRADER" 
                        checked={accountTypeSelected === "ORGANIZATION_TRADER"} 
                        onClick={()=>{
                            if(userPersonalDetails.kyc.length <= 0){
                                setAccountTypeSelected('ORGANIZATION_TRADER')
                                setIndividualPanNumber('');
                                setIndividualPanDOB('');
                                setIndividualPanName('');
                                setShowFirmNameTick(false);
                                setShowFirmNameRolling(false)
                            }
                        }} 
                        disabled={userPersonalDetails.kyc.length>0}
                        />
                        <label for="radio2">Organisation</label>
                    </div> 

                    <div className='kyc-form-container'>
                        {userPersonalDetails.kyc.length>0 && userPersonalDetails.kyc.map((obj,idx)=>{
                            return <div className='kyc-form-rows'>
                                <span className='form-labels'>{obj.type.replace(/_/g, ' ')}</span>
                                <div className='kyc-done-input-container'>
                                    <input className='kyc-form-inputs' value={obj.value} disabled style={{background: "none"}}></input>
                                </div>
                            </div>  
                        })}
                    </div>
                    
                    {accountTypeSelected==='INDIVIDUAL_TRADER' && !userPersonalDetails.kyc.some(obj => obj.type === 'PAN') && <div className='kyc-form-container'>
                        <div className='kyc-form-rows'>
                            <span className='form-labels'>PAN</span>
                            <div className='pan-input-error-container'>
                                <input 
                                    placeholder='Enter PAN' 
                                    className='kyc-form-inputs'
                                    value={individualPanNumber} 
                                    onChange={handlePanNumber}>
                                </input>
                                <span className="panNumberError" style={{color:"red"}}>Please Enter Valid Pan Number</span>
                            </div>
                            
                        </div>
                        <div className='kyc-form-rows'>
                            <span className='form-labels'>Name</span>
                            <div className='pan-input-error-container'>
                                <input 
                                    placeholder='Enter your name as given in PAN' 
                                    className='kyc-form-inputs panNameInput'
                                    value={individualPanName}
                                    disabled 
                                >
                                </input>
                            </div>
                        </div>
                        <div className='kyc-form-rows'>
                            <span className='form-labels'>Date of Birth</span>
                            <div className='pan-input-error-container'>
                                <DatePicker
                                    selected={individualPanDOB ? individualPanDOB : ""}
                                    onChange={(date) => {handlePanDOBChange(date)}}
                                    onBlur={(event) => {
                                        if (!event.target.value) {
                                            handlePanDOBChange('');
                                        }
                                    }}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Enter DOB | DD/MM/YYYY"
                                    className="kyc-form-inputs"
                                    showMonthDropdown
                                    showYearDropdown
                                    yearDropdownItemNumber={12} 
                                    dropdownMode="select"
                                    // customInput={<CustomInput />}
                                />
                                <span className="PanDobError" style={{color:"red"}}>Please Enter DOB in correct format</span>
                            </div>
                        </div>
                        <div className='addMoreID-save-conatiner'>
                            <button className={`addIdBtn ${!userPersonalDetails.kyc.some(obj => obj.type === 'PAN') ? 'disable-addId-btn' : ''}`} disabled>Add ID +<img></img></button>
                            <button className={`saveChangesBtn ${ individualPanNumber !== '' && individualPanName !== '' && individualPanDOB !== '' ? 'enable-savechanges-btn' : ''}`} disabled={individualPanNumber === '' || individualPanName === '' || individualPanDOB === ''} onClick={handleSavePANchanges}>Save Changes</button>
                        </div>
                    </div>}
                    {accountTypeSelected==='ORGANIZATION_TRADER' && !userPersonalDetails.kyc.some(obj => obj.type === 'PAN') && <div className='kyc-form-container'>
                        <div className='kyc-form-rows'>
                            <span className='form-labels'>Business PAN</span>
                            <div className='pan-input-error-container'>
                                <input 
                                    placeholder='Enter Business PAN' 
                                    className='kyc-form-inputs'
                                    value={individualPanNumber} 
                                    onChange={handlePanNumber}
                                    maxLength={10}>
                                   
                                </input>
                                <span className="panNumberError" style={{color:"red"}}>Please Enter Valid Pan Number</span>
                            </div>
                            
                        </div>
                        <div className='kyc-form-rows'>
                            <span className='form-labels'>Date of Incorporation</span>
                            <div className='pan-input-error-container'>
                                <DatePicker
                                    selected={individualPanDOB ? individualPanDOB : ""}
                                    onChange={(date) => {handlePanDOBChange(date)}}
                                    onBlur={(event) => {
                                        if (!event.target.value) {
                                            handlePanDOBChange('');
                                        }
                                    }}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Enter Date of Incorporation | DD/MM/YYYY"
                                    className="kyc-form-inputs"
                                    showMonthDropdown
                                    showYearDropdown
                                    yearDropdownItemNumber={12}
                                    dropdownMode="select"
                                />
                                <span className="PanDobError" style={{color:"red"}}>Please Enter DOB in correct format</span>
                            </div>
                        </div>
                        <div className='kyc-form-rows firm-name-row'>
                            <div className='pan-input-error-container'  style={{flexDirection: "row" , justifyContent : "space-between"}}>
                                <span className='firmNameTextContainer'><img src={firmNameImg}></img> <span className={`firmNameText ${individualPanName !== '' ? "greenFetchedFirmName":""}`}>{individualPanName === '' ?"FIRM NAME":individualPanName }</span></span>
                                {showFirmNameRolling? <img src={greenRolling} className='rollingImage'></img> :""}
                                {showFirmNameTick ? <img src={greenTick}></img> : ""}
                            </div>
                        </div>
                        <div className='addMoreID-save-conatiner'>
                            <button className={`addIdBtn ${!userPersonalDetails.kyc.some(obj => obj.type === 'PAN') ? 'disable-addId-btn' : ''}`} disabled>Add ID +<img></img></button>
                            <button className={`saveChangesBtn ${ individualPanNumber !== '' && individualPanName !== '' && individualPanDOB !== '' ? 'enable-savechanges-btn' : ''}`} disabled={individualPanNumber === '' || individualPanName === '' || individualPanDOB === ''} onClick={handleSavePANchanges}>Save Changes</button>
                        </div>
                    </div>}
                    
                    {userPersonalDetails.kyc.some(obj => obj.type === 'PAN') && <div className='kyc-form-container'>
                        <div className='addIdBtn-container'>
                            <button className='addIdBtn' onClick={handleAddIdBtn} disabled={addIdsList.length===0} style={{ zIndex: showAddIdSelectPopup ? 999 : 'unset' }}>Add ID <img src={showAddIdSelectPopup? greenCross : greenPlus}></img></button>
                        </div>
                        <Popup open={showAddIdSelectPopup} className="addIdPopup" closeOnDocumentClick={false}>
                            <div className='modal-header addIdHeader'>
                                <div className='leftHeading-container'> 
                                    <img src={idType}></img>
                                    <span>Select ID type</span>
                                </div>
                                <img src={greenCross} className='crossAddItemPopupImg' onClick={handleAddIdBtn}></img>
                            </div>
                            <div className="modal-content addIdModal-content">
                                {addIdsList.map((obj,idx)=>{
                                    return <div className='addItemRow'>
                                        <label for={`option${idx+1}`} className='addItemLabel'>{obj.label}</label>
                                        <input type="radio" id={`option${idx+1}`} name="options" value={obj.value} checked={itemToAddKyc === obj.value} onChange={(e) => setItemToAddKyc(e.target.value)}></input>
                                    </div>
                                })}
                                <button className={`addItemSubmit ${itemToAddKyc === '' ? 'disabledAddItemSubmit' : ""}`} onClick={handleAddItemSubmit}>Submit</button>
                            </div>
                        </Popup>
                        <Popup open={selectedKYCItemFieldsPopup} className="selectedKYCItemFieldsPopup" closeOnDocumentClick={false}>
                            <div className='modal-header selectedKYCItemFieldsPopup-header'>
                                <div className='cross-header'>
                                    <img src={crossInput} onClick={handleAdditemKycCross} style={{cursor: 'pointer'}}></img>
                                </div>
                                <div className='heading-header'>
                                    <img className="fingerPrintImg" src={fingerPrint}></img>
                                    <span>Adding New ID</span>
                                </div>
                            </div>
                            <div className="modal-content selectedKYCItemFields-content">
                                <div className='selectedItemToAddInputsRows-container'>
                                    {itemToAddKyc === "AADHAR" ?
                                        <>
                                         <div className='selectedItemToAddInputs-row'>
                                             <span className='form-labels'>Name</span>
                                             <input 
                                                 placeholder='Enter Name on Aadhar Card' 
                                                 className='form-inputs' 
                                                 value={itemToAddKycName} 
                                                 onChange={(e)=>{
                                                     const inputValue = e.target.value;
                                                     const pattern = /^[A-Za-z\s]*$/; 
                                                     if (pattern.test(inputValue)) {
                                                         setItemToAddKycName(e.target.value);
                                                     }
                                                 }}
                                                 >
                                             </input>
                                         </div>
                                         <div className='selectedItemToAddInputs-row'>
                                             <span className='form-labels'>Aadhar Card</span>
                                             <input 
                                                 placeholder='Enter Aadhar Number' 
                                                 className='form-inputs' 
                                                 value={itemToAddKycValue} 
                                                 onChange={(e)=>{
                                                     const regex = /^[0-9]*$/; 
                                                     if (regex.test(e.target.value)) {
                                                         setItemToAddKycValue(e.target.value);
                                                         handleAdharNumberChange(e);
                                                     }
                                                 }}
                                                 maxLength={12}
                                                 >
                                             </input>
                                         </div>
                                         { 
                                             showUploadAdhar ?
                                             <div className='selectedItemToAddInputs-row'>
                                                 <span className='form-labels'>Upload Aadhar File</span>
                                                 <input
                                                     id="file-input"
                                                     type="file"
                                                     style={{display:"none"}}
                                                     onChange={handleFileSelect}
                                                     ref={fileInputRef}
                                                 />
                                                 <input
                                                     placeholder="Upload Aadhar Document"
                                                     className="form-inputs"
                                                     onClick={handleFileInputClick}
                                                     readOnly
                                                     id="file-name-input"
                                                 />
                                             </div> 
                                             :""
                                         }
                                         <Popup open={showAdharConsentPopup} className="aadhar-consent-popup" closeOnDocumentClick={false}>
                                            <div className='modal-header aadhar-consent-header'>
                                                <div className='cross-header'>
                                                    <img src={crossInput} onClick={handleAadharConsentPopupCross} style={{cursor:"pointer"}}></img>
                                                </div>
                                                <div className='aadhar-consent-Heading'><span>Aadhar Consent</span></div>
                                            </div>
                                            <div className="modal-content aadhar-consent-modal-content">
                                                <span className='aadhar-consent-para1'>Upon clicking on this link and sharing the Aadhaar number, You (the Aadhaar holder), hereby irrevocably:</span>
                                                <span className='aadhar-consent-para2'>1. Place a request to Origo Commodities India Private Limited or any of its Group Companies,
                                                        Associates, Subsidiaries or Holding Companies to access Your Aadhaar Information from
                                                        UIDAI to fetch and verify information regarding Aadhaar Number, Aadhaar XML, Virtual ID, e-Aadhaar,
                                                         Masked Aadhaar, Aadhaar details, demographic information, identity information, Aadhaar registered 
                                                         mobile number, face authentication details and/or biometric information (collectively referred to as 
                                                         “Aadhaar Information”).
                                                        <br></br>
                                                        2. Explicitly authorise Origo Commodities India Private Limited or any of its Group Companies, 
                                                        Associates, Subsidiaries or Holding Companies to fetch Your Aadhaar Information from UIDAI 
                                                        to make it available to Origo Commodities India Private Limited or any of its Group Companies, 
                                                        Associates, Subsidiaries or Holding Companies or any third party, as may be required for the purpose 
                                                        of credit appraisal/sharing for any other purpose.
                                                        <br></br>
                                                        3. Agree to take all the necessary actions required for the purpose of authenticating and verifying Your Aadhaar Information.
                                                        <br></br>
                                                        4. Give a valid, binding, irrevocable and explicit authorisation and consent as may be required
                                                        under applicable laws, rules, regulations and guidelines for availing the Aadhaar API services including, but not limited to the transmission and storage of Your Aadhaar Information by Origo Commodities India Private Limited or any of its Group Companies,
                                                        Associates, Subsidiaries or Holding Companies.
                                                        <br></br>
                                                        5. Understand and agree that the Consent has been submitted by You voluntarily and without
                                                        any coercion, misrepresentation from Origo Commodities India Private Limited or any of
                                                        its Group Companies, Associates, Subsidiaries or Holding Companies or any other party.
                                                        <br></br>
                                                        6. Fully understand and accept sole and complete responsibility for any issues, legal suits, damages, 
                                                        losses, penalties, 
                                                        fines or liabilities (“Losses”) arising out of Your sharing of Aadhaar Information and 
                                                        authorising Origo Commodities India Private Limited or any of its Group Companies, Associates, 
                                                        Subsidiaries or Holding Companies for fetching your Aadhar Information and that You will fully hold 
                                                        harmless Origo Commodities India Private Limited or any of its Group Companies, Associates, Subsidiaries 
                                                        or Holding Companies, its representatives, employees and directors for any Losses arising out of such request
                                                         and actions.
                                                    </span>
                                            </div>
                                            <div className='whiteShadow'></div>
                                        </Popup>
                                         {
                                            showUploadAdhar ?
                                                <div className='selectedItemToAddInputs-row checkbox-row'>
                                                    <div className='checkbox-text-container'>
                                                        {/* <label className='checkbox-label' > */}
                                                            <input
                                                                id="aadharConsentCheckbox"
                                                                type="checkbox"
                                                                className='checkBox'
                                                                checked={isCheckedAadharConsent}
                                                                onChange={(e)=>{handleCheckboxChange(e)}}
                                                            />
                                                            <span className='agree-aadhar-consent-text'>I agree to the T&C for the <span className='Aadhar_consent_text' onClick={handleShowAadharConsent}>Aadhar Consent <img classname="info-aadhar-consent" src={infoAdharConsent}></img></span></span>
                                                        {/* </label> */}
                                                    </div>
                                                </div>
                                            :""
                                         }
                                     </> :""
                                    }
                                    { itemToAddKyc === "VOTER_ID" ?
                                        <>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>Voter Id</span>
                                                <input 
                                                    placeholder='Enter Voter Id' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycValue} 
                                                    onChange={(e)=>{
                                                        var voterpattern = /^[A-Za-z0-9]+$/;
                                                        const inputValue = e.target.value;
                                                        if (inputValue === "" || voterpattern.test(inputValue)) {
                                                            setItemToAddKycValue(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                    maxLength={10}
                                                    >
                                                </input>
                                            </div>
                                        </> :""
                                    }
                                    { itemToAddKyc === "DRIVING_LICENSE" ?
                                        <>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>DL Number</span>
                                                <input 
                                                    placeholder='Enter DL Number' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycValue} 
                                                    onChange={(e)=>{
                                                        var DLpattern = /^[A-Za-z0-9]+$/;
                                                        const inputValue = e.target.value;
                                                        if (inputValue === "" || DLpattern.test(inputValue)) {
                                                            setItemToAddKycValue(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                    maxLength={15}
                                                    >
                                                </input>
                                            </div>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>Date of Birth</span>
                                                <DatePicker
                                                    selected={itemToAddKycDOB ? itemToAddKycDOB : ""}
                                                    onChange={(date) => {setItemToAddKycDOB(date)}}
                                                    onBlur={(event) => {
                                                        if (!event.target.value) {
                                                          setItemToAddKycDOB('');
                                                        }
                                                    }}
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Enter DOB | DD/MM/YYYY"
                                                    className="form-inputs"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={12} 
                                                    dropdownMode="select"
                                                />
                                            </div>
                                        </> :""
                                    }
                                    { itemToAddKyc === "PASSPORT" ?
                                        <>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>Passport Number</span>
                                                <input 
                                                    placeholder='Enter Passport Number' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycValue} 
                                                    onChange={(e)=>{
                                                        var PASSPORTpattern = /^[A-Za-z0-9]+$/;
                                                        const inputValue = e.target.value;
                                                        if (inputValue === "" || PASSPORTpattern.test(inputValue)) {
                                                            setItemToAddKycValue(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                    maxLength={8}
                                                    >
                                                </input>
                                            </div>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>Name</span>
                                                <input 
                                                    placeholder='Enter Name as per Passport' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycName} 
                                                    onChange={(e)=>{
                                                        const inputValue = e.target.value;
                                                        const pattern = /^[A-Za-z\s]*$/; 
                                                        if (inputValue === "" || pattern.test(inputValue)) {
                                                            setItemToAddKycName(e.target.value);
                                                        }
                                                    }}
                                                    >
                                                </input>
                                            </div>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>Date of Birth</span>
                                                <DatePicker
                                                    selected={itemToAddKycDOB ? itemToAddKycDOB : ""}
                                                    onChange={(date) => {setItemToAddKycDOB(date)}}
                                                    onBlur={(event) => {
                                                        if (!event.target.value) {
                                                          setItemToAddKycDOB('');
                                                        }
                                                    }}
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Enter DOB | DD/MM/YYYY"
                                                    className="form-inputs"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={12} 
                                                    dropdownMode="select"
                                                />
                                            </div>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>File Number</span>
                                                <input 
                                                    placeholder='Enter File Number' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycFileNo} 
                                                    onChange={(e)=>{
                                                        const inputValue = e.target.value;
                                                        var fileNoPattern = /^[A-Za-z0-9]+$/
                                                        if (inputValue === "" || fileNoPattern.test(inputValue)) {
                                                            setItemToAddKycFileNo(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                    >
                                                </input>
                                            </div>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>Date of Issue</span>
                                                <DatePicker
                                                    selected={itemToAddKycDateOfIssue ? itemToAddKycDateOfIssue : ""}
                                                    onChange={(date) => {setItemToAddKycDateOfIssue(date)}}
                                                    onBlur={(event) => {
                                                        if (!event.target.value) {
                                                            setItemToAddKycDateOfIssue('');
                                                        }
                                                    }}
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Enter DOI | DD/MM/YYYY"
                                                    className="form-inputs"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={12} 
                                                    dropdownMode="select"
                                                />
                                            </div>
                                        </> :""
                                    }
                                    { itemToAddKyc === "BANK_ACCOUNT" ?
                                        <>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>Account Number</span>
                                                <input 
                                                    placeholder='Enter Account Number' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycValue} 
                                                    onChange={(e)=>{
                                                        const inputValue = e.target.value;
                                                        var Bankpattern =/^[0-9]+$/;
                                                        if (inputValue === "" || Bankpattern.test(inputValue)) {
                                                            setItemToAddKycValue(e.target.value);
                                                        }
                                                    }}
                                                    maxLength={16}
                                                    >
                                                </input>
                                            </div>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>IFSC</span>
                                                <input 
                                                    placeholder='Enter IFSC Code' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycIFSC} 
                                                    onChange={(e)=>{
                                                        const inputValue = e.target.value;
                                                        var IFSCpattern = /^[A-Za-z0-9]+$/;
                                                        if (inputValue === "" || IFSCpattern.test(inputValue)) {
                                                            setItemToAddKycIFSC(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                    maxLength={11}
                                                    >
                                                </input>
                                            </div>
                                        </> :""
                                    }
                                    { itemToAddKyc === "UDYOG_AADHAR" ?
                                        <>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>UDYOG AADHAR Number</span>
                                                <input 
                                                    placeholder='Enter UDYOG AADHAR Number' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycValue} 
                                                    onChange={(e)=>{
                                                        const inputValue = e.target.value;
                                                        var udyogpattern = /^[A-Za-z0-9]+$/;
                                                        if (inputValue === "" || udyogpattern.test(inputValue)) {
                                                            setItemToAddKycValue(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                    maxLength={12}
                                                    >
                                                </input>
                                            </div>
                                        </> :""
                                    }
                                    { itemToAddKyc === "GSTIN_NUMBER" ?
                                        <>
                                            <div className='selectedItemToAddInputs-row'>
                                                <span className='form-labels'>GSTIN Number</span>
                                                <input 
                                                    placeholder='Enter GSTIN Number' 
                                                    className='form-inputs' 
                                                    value={itemToAddKycValue} 
                                                    onChange={(e)=>{
                                                        const inputValue = e.target.value;
                                                        var GSTpattern = /^[A-Za-z0-9]+$/;
                                                        if (inputValue === "" || GSTpattern.test(inputValue)) {
                                                            setItemToAddKycValue(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                    maxLength={15}
                                                    >
                                                </input>
                                            </div>
                                        </> :""
                                    }
                                    <div className='selectedItemToAddSubmit-row'>
                                        {itemToAddKyc === "AADHAR" ?
                                            <button className={`addItemSubmit ${(itemToAddKycName === '' || itemToAddKycValue.length<12 || document.getElementById('file-name-input')?.value === '' || isCheckedAadharConsent === false) ? 'disabledAddItemSubmit' : ''}`} onClick={handleAdditemKycSubmit} disabled={(itemToAddKycName === '' || itemToAddKycValue.length<12 || document.getElementById('file-name-input')?.value === '' || isCheckedAadharConsent === false)}>Submit</button>
                                            : ""
                                        }
                                        {itemToAddKyc === "VOTER_ID" ?
                                            <button className={`addItemSubmit ${(itemToAddKycValue.length===0) ? 'disabledAddItemSubmit' : ''}`} onClick={handleAdditemKycSubmit} disabled={(itemToAddKycValue.length===0)}>Submit</button>
                                            : ""
                                        }
                                        {itemToAddKyc === "DRIVING_LICENSE" ?
                                            <button className={`addItemSubmit ${(itemToAddKycValue.length===0 || itemToAddKycDOB === '') ? 'disabledAddItemSubmit' : ''}`} onClick={handleAdditemKycSubmit} disabled={(itemToAddKycValue.length===0 || itemToAddKycDOB === '')}>Submit</button>
                                            : ""
                                        }
                                         {itemToAddKyc === "PASSPORT" ?
                                            <button className={`addItemSubmit ${(itemToAddKycValue.length===0 || itemToAddKycName.length===0 || itemToAddKycFileNo.length === 0 || itemToAddKycDOB === '' || itemToAddKycDateOfIssue === '') ? 'disabledAddItemSubmit' : ''}`} onClick={handleAdditemKycSubmit} disabled={(itemToAddKycValue.length===0 || itemToAddKycName.length===0 || itemToAddKycFileNo.length === 0 || itemToAddKycDOB === '' || itemToAddKycDateOfIssue === '')}>Submit</button>
                                            : ""
                                        }
                                        {itemToAddKyc === "BANK_ACCOUNT" ?
                                            <button className={`addItemSubmit ${(itemToAddKycValue.length===0 || itemToAddKycIFSC.length===0) ? 'disabledAddItemSubmit' : ''}`} onClick={handleAdditemKycSubmit} disabled={(itemToAddKycValue.length===0 || itemToAddKycIFSC.length===0)}>Submit</button>
                                            : ""
                                        }
                                        {itemToAddKyc === "UDYOG_AADHAR" ?
                                            <button className={`addItemSubmit ${(itemToAddKycValue.length === 0) ? 'disabledAddItemSubmit' : ''}`} onClick={handleAdditemKycSubmit} disabled={(itemToAddKycValue.length === 0)}>Submit</button>
                                            : ""
                                        }
                                        {itemToAddKyc === "GSTIN_NUMBER" ?
                                            <button className={`addItemSubmit ${(itemToAddKycValue.length === 0) ? 'disabledAddItemSubmit' : ''}`} onClick={handleAdditemKycSubmit} disabled={(itemToAddKycValue.length === 0)}>Submit</button>
                                            : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </Popup>
                        <Popup open={itemToAddKycOtpPopup} className="selectedKYCItemOtpPopup" closeOnDocumentClick={false}>
                            <div className='modal-header selectedKYCItemOtpPopup-header'>
                                <div className='cross-header'>
                                    <img src={crossInput} onClick={handleAdharOtpPopupCross} style={{cursor:"pointer"}}></img>
                                </div>
                                <div className='heading-header'>
                                    <img src={adharLogo}></img>
                                    <span>Aadhar Verification</span>
                                </div>
                            </div>
                            <div className="modal-content selectedKYCItemFields-content">
                                <div className='selectedItemToAddInputsRows-container'>
                                    <div className='selectedItemToAddInputs-row'>
                                        <span className='form-labels'>Enter OTP</span>
                                        <div className='otpBoxesContainer'>
                                            <input 
                                            placeholder="x" 
                                            type="text" 
                                            pattern="\d*" 
                                            id='ist' 
                                            maxlength="1"
                                            className='adharOtpFields'
                                            onKeyUp={(event)=>{clickEvent(event.target,'sec')}}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[0-9]*$/; 
                                                if (regex.test(value)) {
                                                    _onChangeOTP(e, 0);
                                                } else {
                                                e.target.value = '';
                                                }
                                            }}
                                            onKeyDown={(e) => _onKeyDownOTP(e, 0)}
                                            value={itemToAddKycAdharOtpValue.length>0 && itemToAddKycAdharOtpValue[0] || ""}
                                            />
                                            <input 
                                            placeholder="x" 
                                            type="text" 
                                            pattern="\d*" 
                                            id="sec" 
                                            maxlength="1"
                                            className='adharOtpFields'
                                            onKeyUp={(event)=>{clickEvent(event.target,'third')}}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[0-9]*$/; 
                                                if (regex.test(value)) {
                                                    _onChangeOTP(e, 1);
                                                } else {
                                                e.target.value = '';
                                                }
                                            }}
                                            onKeyDown={(e) => _onKeyDownOTP(e, 1)}
                                            value={itemToAddKycAdharOtpValue.length>0 && itemToAddKycAdharOtpValue[1] || ""}
                                            />
                                            <input 
                                            placeholder="x" 
                                            type="text" 
                                            pattern="\d*" 
                                            id="third" 
                                            maxlength="1"
                                            className='adharOtpFields'
                                            onKeyUp={(event)=>{clickEvent(event.target,'fourth')}}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[0-9]*$/; 
                                                if (regex.test(value)) {
                                                    _onChangeOTP(e, 2);
                                                } else {
                                                e.target.value = '';
                                                }
                                            }}
                                            onKeyDown={(e) => _onKeyDownOTP(e, 2)}
                                            value={itemToAddKycAdharOtpValue.length>0 && itemToAddKycAdharOtpValue[2] || ""}
                                            />
                                            <input 
                                            placeholder="x" 
                                            type="text" 
                                            pattern="\d*" 
                                            id="fourth"
                                            onKeyUp={(event)=>{clickEvent(event.target,'fifth')}} 
                                            maxlength="1"
                                            className='adharOtpFields'
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[0-9]*$/; 
                                                if (regex.test(value)) {
                                                    _onChangeOTP(e, 3);
                                                } else {
                                                e.target.value = '';
                                                }
                                            }}
                                            onKeyDown={(e) => _onKeyDownOTP(e, 3)}
                                            value={itemToAddKycAdharOtpValue.length>0 && itemToAddKycAdharOtpValue[3] || ""}
                                            />
                                             <input 
                                            placeholder="x" 
                                            type="text" 
                                            pattern="\d*" 
                                            id="fifth"
                                            onKeyUp={(event)=>{clickEvent(event.target,'sixth')}} 
                                            maxlength="1"
                                            className='adharOtpFields'
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[0-9]*$/; 
                                                if (regex.test(value)) {
                                                    _onChangeOTP(e, 4);
                                                } else {
                                                e.target.value = '';
                                                }
                                            }}
                                            onKeyDown={(e) => _onKeyDownOTP(e, 4)}
                                            value={itemToAddKycAdharOtpValue.length>0 && itemToAddKycAdharOtpValue[4] || ""}
                                            />
                                             <input 
                                            placeholder="x" 
                                            type="text" 
                                            pattern="\d*" 
                                            id="sixth"
                                            onKeyUp={(event)=>{clickEvent(event.target,'seventh')}} 
                                            maxlength="1"
                                            className='adharOtpFields'
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[0-9]*$/; 
                                                if (regex.test(value)) {
                                                    _onChangeOTP(e, 5);
                                                } else {
                                                e.target.value = '';
                                                }
                                            }}
                                            onKeyDown={(e) => _onKeyDownOTP(e, 5)}
                                            value={itemToAddKycAdharOtpValue.length>0 && itemToAddKycAdharOtpValue[5] || ""}
                                            />
                                        </div>
                                    </div>
                                    <div className='selectedItemToAddCounter-row'>
                                        <div className='selectedItemToAddCounter-container'>
                                            <span>OTP has been sent on your Aadhar registered mobile number</span>
                                            <span style={{color:"#757575"}}>Didn’t receive an OTP? <span style={{color:"#04B23D"}}>00:{counter}</span>
                                            {
                                                +counter === 0 ? (
                                                    <span style={{cursor: "pointer" , color:"#04B23D"}} onClick={handleResendOtp}>Resend</span>
                                                ) : (
                                                    <span style={{cursor: "text" , color:"#D3D3D3"}}>Resend</span>
                                                )
                                            }</span>
                                        </div>
                                    </div>
                                    <div className='selectedItemToAddSubmit-row'>
                                        <button className={` addItemSubmit addItemOtpVerify ${itemToAddKycAdharOtpValue.length<6 ? 'disabledAddItemSubmit' : "addItemSubmit"}`} onClick={handleOtpverifyBtn}>Verify</button>
                                    </div>
                                </div>
                            </div>
                        </Popup>
                        <Popup open={successfullyAddedKycPopup} className="successfullyAddedKycPopup" closeOnDocumentClick={false}>
                            <div className='modal-header successfullyAddedKycPopup-header'>
                                <div className='cross-header'>
                                    <img src={crossInput} onClick={handleSuccessfullyAddedKycPopupCross} style={{cursor:"pointer"}}></img>
                                </div>
                            </div>
                            <div className="modal-content successfullyAddedKycPopup-modalContent">
                                <div className='laptop-hr-conatiner'>
                                    <img src={successLaptop}></img>
                                    <hr className='laptopBottomHr'></hr>
                                </div>
                                <span className="successfullyAddedText">You have successfully added your {userPersonalDetails?.kyc[userPersonalDetails.kyc.length - 1]?.type}</span>
                                <button className='AddAnotherIdBtn' onClick={handleAddAnotherKyc}>Add Another ID</button>
                                <span className='backToHome' onClick={()=>{history.push('/postreg')}} style={{cursor:"pointer"}}>Back to Home</span>
                            </div>
                        </Popup>
                    </div>}
                </div>
            }
            { activeTab === "help" && 
                <div className='help-div'>
                    <span className='faq-heading'>Frequently asked Questions</span>
                    <div className='help-tabs'>
                        <div className={`ecash-btn ${activeHelpTab === 'emandi' ? 'active-ecash-btn' : ''}`} onClick={()=>{handleHelpTabChange("emandi")}}>eMandi</div>
                        <div className={`ecash-btn ${activeHelpTab === 'ecash' ? 'active-ecash-btn' : ''}`} onClick={()=>{handleHelpTabChange("ecash")}}>eCash</div>
                    </div>
                    <div className='QA-container'>
                        {activeHelpTab === 'ecash' ? <div className='left-qa-div'>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>What is eCash?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>eCash allows instant cash against supplies upto 2 Cr with ZERO collateral and fully digital documentation & disbursement.</div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>What is the Objective of eCash?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>eCash provides easy access to working capital for agri supply businesses such as those dealing in maize, wheat, refined wheat flour, etc. Do more trades with Origo eCash credit access. </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>Who can use eCash? </div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>SMEs supplying Agri Commodities such as maize, paddy, wheat, soybean, etc. to processors, corporate buyers, FMCG companies, etc. can use eCash for their working capital needs. </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>How is eCash unique?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>eCash is one of a kind fintech solution for agri supply chain offering instant cash with ZERO collateral, fully digitised evaluation process & speedy disbursement to help suppliers grow their business without being strapped for working capital. </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>How do I register myself?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>Any user can register on eMandi platform via their mobile number. In order to avail eCash credit facility, they need to follow the process of submitting their KYC & business financials. </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>What all documents are required for using eCash? </div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>1 KYC for Proprietor/Partners/Directors (depending on type of business entity) 
                                    * PAN Card
                                    * Any one of Aadhar/Passport/Voter ID"        
                                    2. Business PAN        
                                    3. GST Certificate        
                                    4. Registration Partnership Deed in case of Partnership firm/ Registration Certificate MOA/AOA in case of Companies
                                    5.  Udyam Certificate  (Optional)
                                </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>How is my credit limit evaluated? </div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>Using our in-house proprietary algorithms, we assign a credit limit based on the documents & financials submitted by the applicant. </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>How do I contact support? </div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>You can reach out to us at +91-8338-04-7777 to connect with our dedicated relationship management team. If you want to reach us via WhatsApp, you can drop us a message on the same number : 8338-04-7777 </div>
                            </div>
                        </div> 
                        :
                        <div className='left-qa-div'>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>Who can register on Origo eMandi?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>Any user can register on eMandi platform via their mobile number. In order to avail eCash or any other credit facility, they need to follow the process of submitting their KYC & business financials as per the relevant product. </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>Can I register as both Individual as well as an Organisation?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>You can only register and complete your KYC either as an individual or as an organisation. You can change the type of entity, i.e, Individual or Organisation,  before KYC completion.</div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>Is there any cost involved for registration and KYC?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>No, there is no cost involved for registration and KYC. 
                                    Once you upload the required documents according to your user type (Individual or Organisation) - PAN Card, Aadhar Card/Voter ID/Driving License/Passport - the system captures the information and completes your KYC. 
                                    Incase of any error, our representative will get in contact with you.
                                </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>Can I add IDs with different names?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>For a particular entity, the names registered in the IDs uploaded should be the same as the KYC.
                                    Incase there is some discrepancy, the system will update the name in the profile as per the KYC.
                                </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>Can I edit KYC details after the completion of KYC?</div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>No, you can not edit KYC details (PAN and ID verification) after KYC completion. </div>
                            </div>
                            <div className='ques-ans-div'>
                                <div className='ques-div' onClick={toggleAnswer}>
                                    <div className='ques'>How do I contact support? </div>
                                    <img className="open-ans-arrow-img" src={dropdownArrow}></img>
                                </div>
                                <div className='ans'>You can reach out to us at +91-8338-04-7777 to connect with our dedicated relationship management team. If you want to reach us via WhatsApp, you can drop us a message on the same number : 8338-04-7777 </div>
                            </div>
                        </div>}
                            <div  className='right-qa-div'>
                                <div className='help-card'>
                                    <div className='help-card-text'>
                                        <span className='help-text-upper'>Can’t find what you are looking for?</span>
                                        <span className='help-text-lower'>Contact our eMandi executive</span>
                                    </div>
                                    <img src={helpLaptop}></img>
                                </div>
                            </div>
                    </div>
                </div>
            } 
            <Footer />
            </Scrollbars>
            <FixedAppDirectingFooter/>
        </div>
    </div>
  )
}

export default ProfileSectionPostReg